<template>
  <div class="specs">
    <div class="page">
      <div class="title">
        <h1>Especificações</h1>
        <hr />
        <!-- <div class="custom-select">
          <select class="selectVersao" disabled>
            <option selected value="versao1">Versão 2.34</option>
          </select>
        </div> -->
      </div>

      <div class="corpoEspeficacoes">
        <h4 class="mt-3">Introdução</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.introducao }}</p>
        <h4 class="mt-2">Objetivo</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.objetivo }}</p>
        <h4 class="mt-2">Premissas</h4>
        <p class="mb-1" style="white-space: pre-wrap">{{ dados.premissas }}</p>

        <h4 class="mt-1">Url's base</h4>
        <div class="parteMeioCards mt-2 mb-1">
          <div class="cardCorpo1">
            <span class="text-card">URL Aceite W:</span>
            <span class="text-card">URL Aceite Y:</span>
            <span class="text-card">URL Produção:</span>
          </div>
          <div class="cardCorpo2">
            <span class="text-card2">{{ dados.urlAceiteW }}</span>
            <span class="text-card2">{{ dados.urlAceiteY }}</span>
            <span class="text-card2">{{ dados.urlProducao }}</span>
          </div>
        </div>

        <h4 v-if="(dados.listaAutenticacaoAceite  && dados.listaAutenticacaoAceite.length > 0) || (dados.listaAutenticacaoProducao  && dados.listaAutenticacaoProducao.length > 0)" class="mt-1">Autenticação </h4>
        <div v-if="(dados.listaAutenticacaoAceite  && dados.listaAutenticacaoAceite.length > 0) || (dados.listaAutenticacaoProducao  && dados.listaAutenticacaoProducao.length > 0)">
          <span class="text-card">Aceite W e Y</span>
          <div class="parteMeioCards mt-2 mb-1">
            <div class="cardCorpo1">
              <span
                    v-for="(item, index) in dados.listaAutenticacaoAceite"
                    :key="index"
                  >
                    {{ item.codigo }}:
                  </span>
            </div>
            <div class="cardCorpo2">
              <span
                    v-for="(item, index) in dados.listaAutenticacaoAceite"
                    :key="index"
                  >
                    {{ item.descricao }}
                  </span>
            </div>
          </div>
        </div>
        <div v-if="dados.listaAutenticacaoProducao  && dados.listaAutenticacaoProducao.length > 0">
          <span class="text-card">Produção</span>
          <div class="parteMeioCards mt-2 mb-1">
            <div class="cardCorpo1">
              <span
                    v-for="(item, index) in dados.listaAutenticacaoProducao"
                    :key="index"jh
                  >
                    {{ item.codigo }}:
                  </span>
            </div>
            <div class="cardCorpo2">
              <span
                    v-for="(item, index) in dados.listaAutenticacaoProducao"
                    :key="index"
                  >
                    {{ item.descricao }}
                  </span>
            </div>
          </div>
        </div>

        <!-- Gestão Parceiros == G -->
        <div v-if="dados.apiManager === 'G'">
          <div class="title mt-3 mb-1">
            <h1>
              API Gestão
              <span>POST</span>
            </h1>
          </div>
          <div class="parteMeioCards mt-1 mb-2">
            <div class="cardCorpo1">
              <span class="text-card">URL Token Aceite W:</span>
              <span class="text-card">URL Token Aceite Y:</span>
              <span class="text-card">URL Token Produção:</span>
            </div>
            <div class="cardCorpo2">
              <span class="text-card2">https://servicos-aceitew.tokiomarine.com.br/wscorretor/rest/Corretor/login</span>
              <span class="text-card2">https://servicos-aceitey.tokiomarine.com.br/wscorretor/rest/Corretor/login</span>
              <span class="text-card2">https://servicos.tokiomarine.com.br/wscorretor/rest/Corretor/login</span>
            </div>
          </div>          
          <h4 class="mt-1">Parâmetros:</h4>
          <div class="parteMeioCards mt-1 mb-2">
            <div class="cardCorpo1">
              <span class="text-card">service_key:</span>
              <span class="text-card">user:</span>
              <span class="text-card">password:</span>
            </div>
            <div class="cardCorpo2">
              <span class="text-card2">xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</span>
              <span class="text-card2">yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy</span>
              <span class="text-card2">zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz</span>
            </div>
          </div>
          <div>
            <h4 class="mt-1">Exemplo Request</h4>
          </div>
          <div class="code">
            <div>curl --location 'https://servicos-aceitew.tokiomarine.com.br/wscorretor/rest/Corretor/login' \</div>
            <div>--header 'service_key: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' \</div>
            <div>--header 'Content-Type: application/json' \</div>
            <div>--data '{</div>
            <div>    "user": "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",</div>
            <div>    "password": "zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz"</div>
            <div>}'</div>                
          </div>
          <div>
            <h4 class="mt-2">Exemplo Response</h4>
          </div>
          <div class="code">
            <div>{</div>
            <div class="mt-1 json-indent" >
              <div>"data": {</div>
                <div class="json-indent2">"auth_token": "XXXXXXXXXX.XXXXXXXXXXXXXXXXXXXX.XXXXXXXXXXXXXXXXXXXX.XXXXXXXXXX"</div>
              <div class="json-indent">}</div>
            </div>
            <div>}</div>
          </div>
        </div>
        
        <!-- Api Manager == A -->
        <div v-if="dados.apiManager === 'A'">
          <div class="title mt-4 mb-1">
            <h1>
              API Manager
              <span>POST</span>
            </h1>
          </div>
          <div class="parteMeioCards mb-1">
            <span>https://apim.tokiomarine.com.br/oauth2/v2.0/token</span>
          </div>
          
          <div>
            <h4 class="mt-1">Parametros (FORM)</h4>
          </div>
          <div class="parteMeioCards mt-3 mb-2">
            <div class="cardCorpo1 cardCorpoMenor1">
              <span class="text-card">client_id:</span>
              <span class="text-card">client_secret:</span>
              <span class="text-card">scope:</span>
              <span class="text-card">grant_type:</span>
            </div>
            <div class="cardCorpo2">
              <span class="text-card2">xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</span>
              <span class="text-card2">yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy</span>
              <span class="text-card2">api://zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz/.default</span>
              <span class="text-card2">client_credentials</span>
            </div>
          </div>

          <div>
            <h4 class="mt-1">Exemplo Request</h4>
          </div>
          <div class="code mt-3 mb-2">
            <div>curl --location --request POST 'https://apim.tokiomarine.com.br/oauth2/v2.0/token' \</div>
            <div class="mt-1 json-indent" >
                <div>--header 'Content-Type: application/x-www-form-urlencoded' \</div>
                <div>--header 'Cookie: fpc=AvZys3X-fZtIn5UhYIR3lvucBSKTAQAAANKKl94OAAAA; x-ms-gateway-slice=estsfd; stsservicecookie=estsfd' \</div>
                <div>--data-urlencode 'client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx' \</div>
                <div>--data-urlencode 'client_secret=yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy' \</div>
                <div>--data-urlencode 'scope=api://zzzzzzzz-zzzz-zzzz-zzzz-zzzzzzzzzzzz/.default' \</div>
                <div>--data-urlencode 'grant_type=client_credentials'</div>                
            </div>
          </div>
          
          <div>
            <h4 class="mt-1">Exemplo Response</h4>
          </div>
          <div class="code mt-3">
            <div>{</div>
            <div class="mt-1 json-indent" >
              <div>"token_type": "Bearer",</div>
              <div>"expire_in": 3600,</div>
              <div>"ext_expires_in": 3600,</div>
              <div>"access_token": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"</div>
            </div>
            <div>}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Especificacoes",
  props: {
    dadosApiCatalogo: {
      type: Object,
      default: () => {},
    },
    grupo: String,
    nome: String,
    segmentacao: String
  },
  data() {
    return {
      dados: {},
      subMenuAtual: null,
      subMenuAberto: false,
    };
  },
  // computed() { 

  methods: {
    async carregarDados() {

      try {
        this.dados = this.dadosApiCatalogo;

      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    },
  },
  watch: {
    dadosApiCatalogo: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.dados = newValue;
        } else {
          console.warn(
            "Novos dados recebidos em dadosApiCatalogo são undefined ou vazios."
          );
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.dados = this.dadosApiCatalogo;
  },
  mounted() {
    this.carregarDados();
    setTimeout(() => {
      document.querySelector(".page").classList.add("show");
    }, 500);
  },
};
</script>

<style scoped>
.cardCorpoMenor1 {
  width: 21% !important ;
}

.cardCorpoApiGestao {
  width: 35% !important;
}

.cardCorpo2 {
  width: 80% !important;
}

.cardCorpoMenor2 {
  width: 40% !important ;
}

.json-indent{
  margin-left: 12px !important;
}

.json-indent2{
  margin-left: 22px !important;
}

.container-autenticacao {
  display: flex; 
}

.container-autenticacao-aceite,
.container-autenticacao-prod {
  flex: 1;
  padding: 15px;
}

/* Títulos */
.container-autenticacao-aceite .text-card,
.container-autenticacao-prod .text-card {
  font-weight: bold;
  font-size: 1rem;
  display: block;
  margin-bottom: 10px;
}

.cardCorpo1 {
  max-width: 30% !important;
}

.cardCorpo1,
.cardCorpo2 {
  flex: 1;
}

.cardCorpo1 span,
.cardCorpo2 span {
  display: block;

}

.container-descricao{

    font-size: 10px !important;
  
}


</style>
